import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOurOffice from "./sections/ReachOurOffice";
import OurLocation from "./sections/OurLocation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOurOffice />
      <OurLocation />
      <Footer />
    </div>;
}